import type { IPromoCodeMessageProps } from '../PromoCodeMessage.types'
import { useAppliedPromoCodeContext } from 'routes/hooks/useAppliedPromoCodeContext/useAppliedPromoCodeContext'

export const withPromoAppliedSubscription = (WrappedComponent: Settle.FC<IPromoCodeMessageProps>) => {
  const PromoCodeMessageSubscribed = (props: IPromoCodeMessageProps) => {
    const { promoCode } = useAppliedPromoCodeContext()

    return promoCode?.applied ? <WrappedComponent {...props} /> : null
  }

  return PromoCodeMessageSubscribed
}
